/**
 * @generated SignedSource<<1488576b1b591e504c5491a358f59be9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpCreator_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpCreatorItems_viewer">;
  readonly " $fragmentType": "NftPdpCreator_viewer";
};
export type NftPdpCreator_viewer$key = {
  readonly " $data"?: NftPdpCreator_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpCreator_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpCreator_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpCreatorItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "39ba46106b9382f671e86bf031587c84";

export default node;
